import { render, staticRenderFns } from "./ViewDocsIcon.vue?vue&type=template&id=b48d64aa&scoped=true"
import script from "./ViewDocsIcon.vue?vue&type=script&lang=js"
export * from "./ViewDocsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48d64aa",
  null
  
)

export default component.exports